<template>
  <div class="popup-box__login" v-if="showLoginBox">
    <div class="inner">
      <div class="login-box flex_tablet__jcsb">
        <aside class="left">
          <div class="txt flex__column__aic__jcc">
            <p>{{ info.attr01 }}</p>
            <h3>{{ info.attr02 }}</h3>
          </div>
          <div
            class="img"
            :style="'background-image: url(' + info.picUrl + ');'"
          ></div>
        </aside>
        <aside class="right">
          <div class="formBox">
            <div class="tg" v-show="action == 'register'">
              <div class="tab-name flex__jcc">会员注册</div>
              <el-form
                :model="registerForm"
                :rules="registerRules"
                ref="registerForm"
              >
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="username">
                      <el-input
                        v-model="registerForm.username"
                        placeholder="请输入手机号"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="captcha">
                      <el-input
                        v-model="registerForm.captcha"
                        placeholder="请输入验证码"
                        autocomplete="off"
                      ></el-input>
                      <div
                        class="getCode"
                        :class="isSending ? 'disabled' : ''"
                        @click="getCode"
                      >
                        {{
                          isSending ? "重新发送(" + time + ")" : "获取验证码"
                        }}
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="password">
                    <el-input v-model="registerForm.password"  placeholder="请输入密码" autocomplete="off"></el-input>
                    </el-form-item> 
                  </div>
                </div>
                <div class="btn" @click="register">立即注册</div>
                <div class="has-account flex__jcc">
                  已有账号，<a @click="action = 'login';loginType=0">立即登录</a>
                </div>
                <div
                  class="agree flex__jcc__aifs"
                  :class="isAggree ? 'checked' : ''"
                >
                  <div class="checkbox-ico" @click="isAggree = !isAggree">
                    <i></i>
                  </div>
                  <p>
                    未注册手机验证后自动登录，<br />注册即同意
                    <a @click="openProtocol"
                      >《{{popper.title}}》</a
                    >
                  </p>
                </div>
              </el-form>
            </div>
            <div class="tg" v-show="action == 'login'">
              <div class="tab-name flex__jcc">
                <a
                  :class="loginType == 0 ? 'active' : ''"
                  @click="loginType = 0"
                  >密码登录</a
                >
                <a
                  :class="loginType == 1 ? 'active' : ''"
                  @click="loginType = 1"
                  >短信登录</a
                >
              </div>
              <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
                <template v-if="loginType == 0">
                  <div class="form-item">
                    <div class="form-input">
                      <el-form-item prop="account">
                        <el-input
                          v-model="loginForm.account"
                          placeholder="请输入手机号"
                          autocomplete="off"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="form-input">
                      <el-form-item prop="password">
                        <el-input
                          v-model="loginForm.password"
                          show-password
                          placeholder="请输入登录密码"
                          autocomplete="off"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </template>
                <template v-if="loginType == 1">
                  <div class="form-item">
                    <div class="form-input">
                      <el-form-item prop="phone">
                        <el-input
                          v-model="loginForm.phone"
                          placeholder="请输入手机号"
                          autocomplete="off"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="form-input">
                      <el-form-item prop="code">
                        <el-input
                          v-model="loginForm.code"
                          placeholder="请输入验证码"
                          autocomplete="off"
                        ></el-input>
                        <div
                          class="getCode"
                          :class="isSending ? 'disabled' : ''"
                          @click="getCode"
                        >
                          {{
                            isSending ? "重新发送(" + time + ")" : "获取验证码"
                          }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                </template>
                <div class="btn" @click="login">登 录</div>
                <div
                  class="forget"
                  :class="loginType == 0 ? 'flex__aic__jcsb' : 'flex__jcc'"
                >
                  <a class="go" @click="action = 'forget'" v-if="loginType == 0"
                    >忘记密码</a
                  >
                  <div class="no-accont">
                    没有账号，<a @click="action = 'register'">立即注册</a>
                  </div>
                </div>
                <div
                  class="agree flex__jcc__aifs"
                  :class="isAggree ? 'checked' : ''"
                >
                  <div class="checkbox-ico" @click="isAggree = !isAggree">
                    <i></i>
                  </div>
                  <p>
                    会员登录即同意
                    <a @click="openProtocol"
                      >《{{popper.title}}》</a
                    >
                  </p>
                </div>
              </el-form>
            </div>
            <div class="tg" v-show="action == 'setpassword'">
              <div class="tab-name flex__jcc">设置密码</div>
              <el-form
                :model="setPwdForm"
                :rules="setPwdRules"
                ref="setPwdForm"
              >
                <div class="tip flex__jcc">
                  检测到当前账号未设置密码，请先设置密码
                </div>
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="newPwd">
                      <el-input
                        v-model="setPwdForm.newPwd"
                        show-password
                        placeholder="密码长度8位，至少包含字母、数字"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="confirmPwd">
                      <el-input
                        v-model="setPwdForm.confirmPwd"
                        show-password
                        placeholder="请确认设置密码"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="btns flex__aic">
                  <div class="btn" @click="setPassword">确定，现在登录</div>
                </div>
              </el-form>
            </div>
            <div class="tg" v-show="action == 'forget'">
              <div class="tab-name flex__jcc">重置密码</div>
              <el-form
                :model="forgetForm"
                :rules="forgetRules"
                ref="forgetForm"
              >
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="username">
                      <el-input
                        v-model="forgetForm.username"
                        placeholder="请输入手机号"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="code">
                      <el-input
                        v-model="forgetForm.code"
                        placeholder="请输入验证码"
                        autocomplete="off"
                      ></el-input>
                      <div
                        class="getCode"
                        :class="isSending ? 'disabled' : ''"
                        @click="getCode"
                      >
                        {{
                          isSending ? "重新发送(" + time + ")" : "获取验证码"
                        }}
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="newPwd">
                      <el-input
                        v-model="forgetForm.newPwd"
                        show-password
                        placeholder="请输入您的新密码"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-item">
                  <div class="form-input">
                    <el-form-item prop="confirmPwd">
                      <el-input
                        v-model="forgetForm.confirmPwd"
                        show-password
                        placeholder="请再次输入新密码"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="btns flex__aic">
                  <div class="btn" @click="changePassword">确认修改</div>
                  <div class="btn back" @click="action = 'login'">返回登录</div>
                </div>
              </el-form>
            </div>
          </div>
        </aside>
      </div>
    </div>
    <div class="layer" @click="closePopBox"></div>
    <el-dialog
      :title="popper.title"
      :visible.sync="popper.show"
      width="90%"
      :modal-append-to-body="false"
      custom-class="protocol-dialog"
      :center="true"
    >
      <div class="overscroll" v-html="popper.content"></div>

    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "userLogin",
  components: {},
  data() {
    return {
      info: "",
      showLoginBox: false,
      popper: {
        show: false,
        title: "",
        content: "",
      },
      isSending: false,
      timer: null,
      time: 60,
      action: "login",
      isAggree: false,
      loginType: 0,
      registerForm: {
        giteeToken: "",
        username: "",
        captcha: "",
        password: "",
      },
      registerRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          {
            validator: (rule, value, callback) => {
              let rex = /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]{8,16}$/;
              if (!value) {
                callback(new Error("请输入密码"));
              } else if (!rex.test(value)) {
                callback(new Error("请输入8-16位数字+字母"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      loginForm: {
        account: "",
        phone: "",
        code: "",
        password: "",
      },
      loginRules: {
        account: [
          {
            required: true,
            message: "请输入用户名/手机号/邮箱地址",
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              let rex = /^(?=.*[a-zA-Z])(?=.*\d)[\s\S]{8,16}$/;
              if (!value) {
                callback(new Error("请输入密码"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        phone: [
          { required: false, message: "请输入您的手机号", trigger: "blur" },
        ],
        code: [{ required: false, message: "请输入验证码", trigger: "blur" }],
      },
      setPwdForm: {
        newPwd: "",
        confirmPwd: "",
      },
      setPwdRules: {
        newPwd: [
          {
            validator: (rule, value, callback) => {
              let rex = /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]{8,16}$/;
              if (!value) {
                callback(new Error("请输入密码"));
              } else if (!rex.test(value)) {
                callback(new Error("请输入8-16位数字+字母"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        confirmPwd: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请再次输入密码"));
              } else if (value !== this.setPwdForm.newPwd) {
                callback(new Error("两次密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      forgetForm: {
        username: "",
        code: "",
        newPwd: "",
        confirmPwd: "",
      },
      forgetRules: {
        username: [
          {
            required: true,
            message: "请输入您的手机号/邮箱地址",
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        newPwd: [
          {
            validator: (rule, value, callback) => {
              let rex = /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]{8,16}$/;
              if (!value) {
                callback(new Error("请输入密码"));
              } else if (!rex.test(value)) {
                callback(new Error("请输入8-16位数字+字母"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        confirmPwd: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请再次输入密码"));
              } else if (value !== this.forgetForm.newPwd) {
                callback(new Error("两次密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },

  created() {
    // this.getColumnInfo();
    // this.getProtocol();
    if (this.$route.query.token) {
      this.registerForm.giteeToken = this.$route.query.token;
      this.action = "register";
    }
  },
  beforeDestroy() {
    // 组件销毁时清除定时器，避免内存泄漏
    this.clearTimer();
  },
  watch: {
    action: function () {
      this.isAggree = false;
    },
    loginType: function () {
      let v = this.loginType;
      this.loginRules.account[0].required = !v;
      this.loginRules.password[0].required = !v;
      this.loginRules.phone[0].required = !!v;
      this.loginRules.code[0].required = !!v;
    },
  },
  methods: {
    ...mapMutations(["changeState"]),
    getProtocol() {
      const that = this;
      that.$axios
        .post("article/detail", { id: '1963147863840956418' })
        .then((res) => {
          that.popper.title = res.data.title || "";
          that.popper.content = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openProtocol(){
      this.popper.show = true;
    },
    getColumnInfo() {
      const that = this;
      this.$axios
        .post("ad/list")
        .then((res) => {
          var data = res.data;
          for (var i = 0; i < data.length; i++) {
            const elem = data[i];
            if (elem.id == "1963114196997414913") {
              that.info = elem;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCode() {
      const that = this;
      const phoneRegex = /^1[3-9]\d{9}$/;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      let value = "";
      let accountType;
      switch (that.action) {
        case "register": {
          value = that.registerForm.username;
          break;
        }
        case "login": {
          if (that.loginType) {
            value = that.loginForm.phone;
          } else {
            value = that.loginForm.account;
          }
          break;
        }
        case "forget": {
          value = that.forgetForm.username;
          break;
        }
      }
      if (!value) {
        that.$message({
          message: "请输入您的手机号/邮箱地址",
          type: "error",
        });
        return;
      }
      if (!phoneRegex.test(value) && !emailRegex.test(value)) {
        that.$message({
          message: "手机号/邮箱格式错误",
          type: "error",
        });
        return;
      }
      if (phoneRegex.test(value)) {
        accountType = 2;
      }
      if (emailRegex.test(value)) {
        accountType = 1;
      }
      if (that.isSending) {
        return;
      }
      that.startTimer();
      that.$axios.get('send/getCode?account=' + value + '&accountType=' + accountType).then((res) => {
          that.$message({
            message: "发送成功！",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
          that.clearTimer();
        });
    },
    startTimer() {
      const that = this;
      that.isSending = true;
      that.timer = setInterval(function () {
        if (that.time > 0) {
          that.time--;
        } else {
          that.clearTimer();
        }
      }, 1000);
    },
    clearTimer() {
      const that = this;
      clearInterval(that.timer);
      that.timer = null;
      that.time = 60;
      that.isSending = false;
    },
    register() {
      const that = this;
      that.$refs.registerForm.validate((valid) => {
        if (valid) {
          if (!that.isAggree) {
            that.$message({
              message: "请阅读并同意 《"+that.popper.title+"》",
              type: "error",
            });
            return;
          }
          that.$axios
            .post("verify/register", { ...that.registerForm })
            .then((res) => {
              that.$message({
                message: "注册成功！",
                type: "success",
              });
              that.action = "login";
            })
            .catch((err) => {
              console.log(err);
              that.clearTimer();
            });
        }
      });
    },
    login() {
      const that = this;
      that.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (!that.isAggree) {
            that.$message({
              message: "请阅读并同意 《"+that.popper.title+"》",
              type: "error",
            });
            return;
          }
          let data = {
            username: "",
          };
          if (that.loginType) {
            // 短信登录：只传 username 和 code
            data.username = that.loginForm.phone;
            data.code = that.loginForm.code;
          } else {
            // 密码登录：只传 username 和 password
            data.username = that.loginForm.account;
            data.password = that.loginForm.password;
          }
          that.$axios.post("verify/login", { ...data }).then((res) => {
              that.$message({
                message: "登录成功！",
                type: "success",
              });
              if (res.data.token) {
                localStorage.setItem("Authorization", res.data.token);
              }
              if (res.data.member) {
                localStorage.setItem("member", JSON.stringify(res.data.member));
                that.changeState({
                  member: res.data.member,
                  Authorization: res.data.token,
                });
              }

              // 检查是否需要设置密码
              if (res.data.updatePassword) {
                that.action = "setpassword";
                return; // 不继续执行后续的页面跳转逻辑
              }

              // 登录成功后清除 backurl 并跳转到首页
              if (localStorage.getItem("backurl")) {
                localStorage.removeItem("backurl");
              }
              that.goToPage("/index");
              that.showLoginBox = false;
            })
            .catch((err) => {
              console.log(err);
              that.clearTimer();
            });
        }
      });
    },
    setPassword() {
      const that = this;
      that.$refs.setPwdForm.validate((valid) => {
        if (valid) {
          // 已登录用户设置密码，只需要传 newPwd（Authorization token 已在请求头中）
          // 密码需要加密传输
          const payload = { newPwd: that.encryptPassword(that.setPwdForm.newPwd) };
          that.$axios
            .post("member/modify_pwd", payload)
            .then((res) => {
              that.$message({
                message: "密码设置成功！",
                type: "success",
              });
              // 清空表单
              that.setPwdForm = {
                newPwd: "",
                confirmPwd: "",
              };
              // 重置表单验证状态
              that.$nextTick(() => {
                if (that.$refs.setPwdForm) {
                  that.$refs.setPwdForm.clearValidate();
                }
              });
              that.action = "login";
              that.loginType = 0;
              // 设置密码成功后清除 backurl 并跳转到首页
              if (localStorage.getItem("backurl")) {
                localStorage.removeItem("backurl");
              }
              that.goToPage("/index");
              that.showLoginBox = false;
            })
            .catch((err) => {
              console.log(err);
              // 错误信息已在响应拦截器中统一处理
            });
        }
      });
    },
    changePassword() {
      const that = this;
      that.$refs.forgetForm.validate((valid) => {
        if (valid) {
          // 未登录用户重置密码，需要传 username、code 和 newPwd
          // 密码需要加密传输
          let data = {
            username: that.forgetForm.username,
            code: that.forgetForm.code,
            newPwd: that.encryptPassword(that.forgetForm.newPwd),
          };
          that.$axios
            .post("member/modify_pwd", { ...data })
            .then((res) => {
              that.$message({
                message: "修改成功！",
                type: "success",
              });
              // 清空表单
              that.forgetForm = {
                username: "",
                code: "",
                newPwd: "",
                confirmPwd: "",
              };
              // 重置表单验证状态
              that.$nextTick(() => {
                if (that.$refs.forgetForm) {
                  that.$refs.forgetForm.clearValidate();
                }
              });
              // 清除倒计时
              that.clearTimer();
              that.action = "login";
            })
            .catch((err) => {
              console.log(err);
              // 错误信息已在响应拦截器中统一处理
              // 清除倒计时（如果验证码错误，可能需要重新获取）
              that.clearTimer();
            });
        }
      });
    },
    open(action = 'login') {
      this.action = action;
      this.showLoginBox = true;
    },
    closePopBox() {
      this.showLoginBox = false;
      this.action = "login";
    },
  },
};
</script>